import { useSelector } from "react-redux";
import type { RootState } from "../../../app/store";
import { Toast } from "./Toast";

export const ToastContainer = () => {
	const toasts = useSelector((state: RootState) => state.toast.toasts);

	if (toasts.length === 0) return null;

	return (
		<section
			aria-label="Notifications"
			className="pointer-events-none fixed top-[calc(var(--height-header)+0.75rem)] right-4 z-[30000] flex w-[min(100%-2rem,22.5rem)] flex-col gap-2.5"
		>
			{toasts.map((toast) => (
				<Toast key={toast.id} toast={toast} />
			))}
		</section>
	);
};
